module.exports = __webpack_public_path__ + "img/ts.f3e2956f.svg";